import React from 'react'
import GradientButton from '../Button/GradientButton'

const ButtonGroupPortfolio = ({ selectedtab, setSelectedTab, tabs }) => {
  return (
    <div className="flex gap-x-16 mb-4 pl-2">
        {tabs.map(({ id, Icon, name, }) => {
          if(id === selectedtab){
            return (
              <GradientButton key={id}>
                {Icon && <span><Icon color="#F1F3F4" /></span>}
                <span className={`no-break ${Icon ? 'ml-1': 'ml-0'}`}>{name}</span>
              </GradientButton>
            )
          }
          else{
            return (
              <div key={id} className='flex items-center cursor-pointer' onClick={()=>setSelectedTab(id)}>
                {Icon && <span><Icon color='#8F8F8F' /></span>}
                <span className={`text-[#8F8F8F] no-break ${Icon ? 'ml-2': 'ml-0'}`}>{name}</span>
              </div>
            )
          }
        })}
    </div>
  )
}

export default ButtonGroupPortfolio;
